import { Button, Col, Form, Input, Row, Spin, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import { useState } from "react";
import agblack from "./Images/agblack.png";

const ForgetPassword = () => {
  const [reset, setReset] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [form] = useForm();

  const baseUrl = process.env.REACT_APP_SSO_API;

  const onFinish = (values) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/reset-password`,
        {
          email: values.email.toString().toLocaleLowerCase(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setReset(true);
        success(response.data.success);
        setLoading(false);

		setTimeout(() => {
			window.location.replace("/");
		  }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        warning(error.response.data.error);
      });
  };

  const warning = (message) => {
    Modal.error({
      title: "Validation Error!",
      content: message,
    });
  };

  const success = (message) => {
    Modal.success({
      title: "Success!",
      content: message,
    });
  };

  const onFinishFailed = () => {};

  return (
    <Spin spinning={isLoading}>
      <div>
        {!reset ? (
          <div className="rebrand-forgot-main">
            <div className="rebrand-forgot-main-wrapper">
              <div className="rebrand-forgot-img">
                <img src={agblack} alt="" />
              </div>
              <div className="rebrand-forgot-form">
                <h2>Reset Password</h2>
                <Form
                  name="basic"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  layout="vertical"
                  title="My Form Title"
                >
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your email.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Send Password Reset Link
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        ) : (
          <Row>
            <Col span={24}>
              {/* <h1>Please check you email!!!</h1> */}
            </Col>
          </Row>
        )}
      </div>
    </Spin>
  );
};

export default ForgetPassword;
